// extracted by mini-css-extract-plugin
export default {"controlCustom":"Mapa_controlCustom__vUrX1","head":"Mapa_head__IjUWN","button":"Mapa_button__95tH6","outerEditMarker":"Mapa_outerEditMarker__ilodJ"};